import { Observable } from "../../events";
import { PointerToDragController } from "./map.inputs.controller.drag";
import { PointerToGestureController } from "./map.inputs.controller.touch";
export class InputController {
    constructor(src) {
        this._onContextMenu = (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
        };
        this._onWheel = (ev) => {
            this._onWheelObservable?.notifyObservers(ev);
        };
        this._onPointerOver = (ev) => {
            this._onPointerOverObservable?.notifyObservers(ev);
        };
        this._onPointerEnter = (ev) => {
            this._onPointerEnterObservable?.notifyObservers(ev);
        };
        this._onPointerOut = (ev) => {
            this._onPointerOutObservable?.notifyObservers(ev);
        };
        this._onPointerLeave = (ev) => {
            this._onPointerLeaveObservable?.notifyObservers(ev);
        };
        this._onPointerMove = (ev) => {
            this._onPointerMoveObservable?.notifyObservers(ev);
        };
        this._onPointerDown = (ev) => {
            this._onPointerDownObservable?.notifyObservers(ev);
        };
        this._onPointerUp = (ev) => {
            this._onPointerUpObservable?.notifyObservers(ev);
        };
        this._onPointerCancel = (ev) => {
            this._onPointerCancelObservable?.notifyObservers(ev);
        };
        this._onPointerGotCapture = (ev) => {
            this._onPointerGotCaptureObservable?.notifyObservers(ev);
        };
        this._onPointerLostCapture = (ev) => {
            this._onPointerLostCaptureObservable?.notifyObservers(ev);
        };
        this.source = src;
        this._dragController = new PointerToDragController(this);
    }
    get onDragObservable() {
        return this._dragController.onDragObservable;
    }
    get onTouchObservable() {
        if (!this._touchController) {
            this._touchController = new PointerToGestureController(this);
        }
        return this._touchController.onTouchObservable;
    }
    get onWheelObservable() {
        if (!this._onWheelObservable) {
            this._onWheelObservable = new Observable();
            this._src?.addEventListener("wheel", this._onWheel);
        }
        return this._onWheelObservable;
    }
    get onPointerOverObservable() {
        if (!this._onPointerOverObservable) {
            this._onPointerOverObservable = new Observable();
            this._src?.addEventListener("pointerover", (ev) => {
                this._onPointerOverObservable?.notifyObservers(ev);
            });
        }
        return this._onPointerOverObservable;
    }
    get onPointerEnterObservable() {
        if (!this._onPointerEnterObservable) {
            this._onPointerEnterObservable = new Observable();
            this._src?.addEventListener("pointerenter", this._onPointerEnter);
        }
        return this._onPointerEnterObservable;
    }
    get onPointerOutObservable() {
        if (!this._onPointerOutObservable) {
            this._onPointerOutObservable = new Observable();
            this._src?.addEventListener("pointerout", this._onPointerOut);
        }
        return this._onPointerOutObservable;
    }
    get onPointerLeaveObservable() {
        if (!this._onPointerLeaveObservable) {
            this._onPointerLeaveObservable = new Observable();
            this._src?.addEventListener("pointerleave", this._onPointerLeave);
        }
        return this._onPointerLeaveObservable;
    }
    get onPointerMoveObservable() {
        if (!this._onPointerMoveObservable) {
            this._onPointerMoveObservable = new Observable();
            this._src?.addEventListener("pointermove", this._onPointerMove);
        }
        return this._onPointerMoveObservable;
    }
    get onPointerDownObservable() {
        if (!this._onPointerDownObservable) {
            this._onPointerDownObservable = new Observable();
            this._src?.addEventListener("pointerdown", this._onPointerDown);
        }
        return this._onPointerDownObservable;
    }
    get onPointerUpObservable() {
        if (!this._onPointerUpObservable) {
            this._onPointerUpObservable = new Observable();
            this._src?.addEventListener("pointerup", this._onPointerUp);
        }
        return this._onPointerUpObservable;
    }
    get onPointerCancelObservable() {
        if (!this._onPointerCancelObservable) {
            this._onPointerCancelObservable = new Observable();
            this._src?.addEventListener("pointercancel", this._onPointerCancel);
        }
        return this._onPointerCancelObservable;
    }
    get onPointerGotCaptureObservable() {
        if (!this._onPointerGotCaptureObservable) {
            this._onPointerGotCaptureObservable = new Observable();
            this._src?.addEventListener("gotpointercapture", this._onPointerGotCapture);
        }
        return this._onPointerGotCaptureObservable;
    }
    get onPointerLostCaptureObservable() {
        if (!this._onPointerLostCaptureObservable) {
            this._onPointerLostCaptureObservable = new Observable();
            this._src?.addEventListener("lostpointercapture", this._onPointerLostCapture);
        }
        return this._onPointerLostCaptureObservable;
    }
    get source() {
        return this._src;
    }
    set source(src) {
        if (src !== this._src) {
            this._detachControl(this._src);
            this._src = src;
            this._attachControl(src);
        }
    }
    dispose() {
        this._detachControl(this._src);
        this._clearObservables();
    }
    _attachControl(src) {
        if (src) {
            src.addEventListener("contextmenu", this._onContextMenu.bind(this));
            if (this._onPointerOverObservable) {
                src.addEventListener("pointerover", this._onPointerOver.bind(this));
            }
            if (this._onPointerEnterObservable) {
                src.addEventListener("pointerenter", this._onPointerEnter.bind(this));
            }
            if (this._onPointerOutObservable) {
                src.addEventListener("pointerout", this._onPointerOut.bind(this));
            }
            if (this._onPointerLeaveObservable) {
                src.addEventListener("pointerleave", this._onPointerLeave.bind(this));
            }
            if (this._onPointerMoveObservable) {
                src.addEventListener("pointermove", this._onPointerMove.bind(this), { passive: false });
            }
            if (this._onPointerDownObservable) {
                src.addEventListener("pointerdown", this._onPointerDown);
            }
            if (this._onPointerUpObservable) {
                src.addEventListener("pointerup", this._onPointerUp.bind(this));
            }
            if (this._onPointerCancelObservable) {
                src.addEventListener("pointercancel", this._onPointerCancel.bind(this));
            }
            if (this._onPointerGotCaptureObservable) {
                src.addEventListener("gotpointercapture", this._onPointerGotCapture.bind(this));
            }
            if (this._onPointerLostCaptureObservable) {
                src.addEventListener("lostpointercapture", this._onPointerLostCapture.bind(this));
            }
            if (this._onWheelObservable) {
                src.addEventListener("wheel", this._onWheel.bind(this));
            }
        }
    }
    _detachControl(src) {
        if (src) {
            src.removeEventListener("contextmenu", this._onContextMenu);
            src.removeEventListener("pointerover", this._onPointerOver);
            src.removeEventListener("pointerenter", this._onPointerEnter);
            src.removeEventListener("pointerout", this._onPointerOut);
            src.removeEventListener("pointerleave", this._onPointerLeave);
            src.removeEventListener("pointermove", this._onPointerMove);
            src.removeEventListener("pointerdown", this._onPointerDown);
            src.removeEventListener("pointerup", this._onPointerUp);
            src.removeEventListener("pointercancel", this._onPointerCancel);
            src.removeEventListener("gotpointercapture", this._onPointerGotCapture);
            src.removeEventListener("lostpointercapture", this._onPointerLostCapture);
            src.removeEventListener("wheel", this._onWheel);
        }
    }
    _clearObservables() {
        this._onWheelObservable?.clear();
        this._onPointerOverObservable?.clear();
        this._onPointerEnterObservable?.clear();
        this._onPointerOutObservable?.clear();
        this._onPointerLeaveObservable?.clear();
        this._onPointerMoveObservable?.clear();
        this._onPointerDownObservable?.clear();
        this._onPointerUpObservable?.clear();
        this._onPointerCancelObservable?.clear();
        this._onPointerGotCaptureObservable?.clear();
        this._onPointerLostCaptureObservable?.clear();
        this._onPointerOverObservable = undefined;
        this._onPointerEnterObservable = undefined;
        this._onPointerOutObservable = undefined;
        this._onPointerLeaveObservable = undefined;
        this._onPointerMoveObservable = undefined;
        this._onPointerDownObservable = undefined;
        this._onPointerUpObservable = undefined;
        this._onPointerCancelObservable = undefined;
        this._onPointerGotCaptureObservable = undefined;
        this._onPointerLostCaptureObservable = undefined;
        this._onWheelObservable = undefined;
    }
}
//# sourceMappingURL=map.inputs.controller.js.map